/* Ported from panel.davakhoone.com (TipTap 3 / Vue 3) to TipTap 2 / Vue 2 for sakhtineo. */
function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/** Distinct palette so each tag name keeps a stable color */
const TAG_COLORS = [
  '#569cd6',
  '#4ec9b0',
  '#c586c0',
  '#dcdcaa',
  '#ce9178',
  '#9cdcfe',
  '#d7ba7d',
  '#b5cea8',
  '#f14c4c',
  '#ff7ab2',
  '#79b8ff',
  '#b392f0',
  '#89d185',
  '#f8c555',
  '#e06c75',
  '#56b6c2'
]

const FIXED_TAG_COLORS = {
  div: '#569cd6',
  span: '#c586c0',
  p: '#4ec9b0',
  a: '#79b8ff',
  img: '#ce9178',
  table: '#89d185',
  thead: '#b5cea8',
  tbody: '#b5cea8',
  tr: '#89d185',
  th: '#d7ba7d',
  td: '#b5cea8',
  ul: '#ff7ab2',
  ol: '#ff7ab2',
  li: '#f8c555',
  h1: '#dcdcaa',
  h2: '#dcdcaa',
  h3: '#d7ba7d',
  h4: '#d7ba7d',
  h5: '#f8c555',
  h6: '#f8c555',
  strong: '#e06c75',
  b: '#e06c75',
  em: '#c586c0',
  i: '#c586c0',
  br: '#808080',
  hr: '#808080',
  blockquote: '#b392f0',
  code: '#ce9178',
  pre: '#d7ba7d',
  section: '#56b6c2',
  article: '#56b6c2',
  header: '#79b8ff',
  footer: '#79b8ff',
  nav: '#79b8ff',
  figure: '#4ec9b0',
  figcaption: '#4ec9b0',
  video: '#f14c4c',
  source: '#f14c4c',
  iframe: '#e06c75',
  form: '#89d185',
  input: '#89d185',
  button: '#f8c555',
  label: '#b5cea8',
  style: '#c586c0',
  script: '#e06c75'
}

function tagColor(rawName) {
  const name = String(rawName || '')
    .replace(/^[!?/]+/, '')
    .toLowerCase()
  if (!name) return TAG_COLORS[0]
  if (FIXED_TAG_COLORS[name]) return FIXED_TAG_COLORS[name]

  let hash = 0
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0
  }
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length]
}

function colorSpan(color, html) {
  return `<span class="tok-tag" style="color:${color}">${html}</span>`
}

function highlightTag(tag) {
  let out = ''
  let i = 0
  const len = tag.length
  let color = TAG_COLORS[0]

  if (tag.startsWith('</')) {
    i = 2
  } else if (tag.startsWith('<')) {
    i = 1
  }

  const nameMatch = tag.slice(i).match(/^[!?]?[a-zA-Z][\w:-]*/)
  if (nameMatch) {
    color = tagColor(nameMatch[0])
  }

  if (tag.startsWith('</')) {
    out += colorSpan(color, '&lt;/')
  } else if (tag.startsWith('<')) {
    out += colorSpan(color, '&lt;')
  }

  if (nameMatch) {
    out += colorSpan(color, escapeHtml(nameMatch[0]))
    i += nameMatch[0].length
  }

  while (i < len) {
    const ch = tag[i]

    if (ch === '>' || (ch === '/' && tag[i + 1] === '>')) {
      out += colorSpan(color, escapeHtml(tag.slice(i)))
      break
    }

    if (/\s/.test(ch)) {
      out += ch === ' ' ? ' ' : escapeHtml(ch)
      i += 1
      continue
    }

    const attrName = tag.slice(i).match(/^[\w:-]+/)
    if (attrName) {
      out += `<span class="tok-attr">${escapeHtml(attrName[0])}</span>`
      i += attrName[0].length

      while (i < len && /\s/.test(tag[i])) {
        out += tag[i] === ' ' ? ' ' : escapeHtml(tag[i])
        i += 1
      }

      if (tag[i] === '=') {
        out += '<span class="tok-punct">=</span>'
        i += 1

        while (i < len && /\s/.test(tag[i])) {
          out += tag[i] === ' ' ? ' ' : escapeHtml(tag[i])
          i += 1
        }

        if (tag[i] === '"' || tag[i] === "'") {
          const quote = tag[i]
          let k = i + 1
          while (k < len && tag[k] !== quote) k += 1
          if (k < len) k += 1
          out += `<span class="tok-string">${escapeHtml(tag.slice(i, k))}</span>`
          i = k
        } else {
          const val = tag.slice(i).match(/^[^\s>/]+/)
          if (val) {
            out += `<span class="tok-string">${escapeHtml(val[0])}</span>`
            i += val[0].length
          }
        }
      }
      continue
    }

    out += escapeHtml(ch)
    i += 1
  }

  return out
}

/** HTML syntax highlight with per-tag colors for source overlay */
export function highlightHtmlSource(code) {
  const src = String(code ?? '')
  let out = ''
  let i = 0
  const len = src.length

  while (i < len) {
    if (src.startsWith('<!--', i)) {
      const end = src.indexOf('-->', i + 4)
      const j = end === -1 ? len : end + 3
      out += `<span class="tok-comment">${escapeHtml(src.slice(i, j))}</span>`
      i = j
      continue
    }

    if (src[i] === '<') {
      const closeBracket = src.indexOf('>', i + 1)
      const j = closeBracket === -1 ? len : closeBracket + 1
      out += highlightTag(src.slice(i, j))
      i = j
      continue
    }

    const next = src.indexOf('<', i)
    const j = next === -1 ? len : next
    out += `<span class="tok-text">${escapeHtml(src.slice(i, j))}</span>`
    i = j
  }

  return `${out}\n`
}
